import React, { useEffect, useState } from 'react';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { debounce } from '@awp/helpers/Utils';
import { AwpContainer } from '../Common/AwpContainer';
import { UrlParamTableFilterContextProvider } from '@providers/UrlParamTableFilterContext';
import AvalancheProgramsTable from '@components/AvalanchePrograms/AvalancheProgramsTable';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPrograms, selectAllPrograms } from '@stores/avalancheDashboardViewPageSlice';

const AvalanchePrograms = () => {
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const [isLarge, setIsLarge] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const dispatch = useDispatch();
  const allPrograms = useSelector(selectAllPrograms);

  useEffect(() => {
    setLoading(true);
    dispatch(fetchPrograms());
  }, []);

  useEffect(() => {
    if (allPrograms.length) {
      const programsWithoutAll = allPrograms.filter((program) => program.Id >= 0);
      setData(programsWithoutAll);
      setFilteredData(programsWithoutAll);
      setLoading(false);
    }
  }, [allPrograms]);

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
      setIsLarge(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const tableProps = {
    data,
    setData,
    loading,
    filteredData,
    setFilteredData,
  };

  return (
    <AwpContainer>
      <UrlParamTableFilterContextProvider>
        <AvalancheProgramsTable {...tableProps} />
      </UrlParamTableFilterContextProvider>
    </AwpContainer>
  );
};

export default AvalanchePrograms;
